import { Gap } from 'lib/components/styles/layout';
import styled from 'styled-components/macro';

export const ItemContainer = styled(Gap)`
  height: 64px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #f6f7f9;
`;
